import './init';
import { default as Log } from './lib/log';
export { VERSION } from './utils/globals';
export { self, window, global, document, process, console } from './env/globals';
export { default as isBrowser, isBrowserMainThread } from './env/is-browser';
export { default as getBrowser, isMobile } from './env/get-browser';
export { default as isElectron } from './env/is-electron';
export { default as assert } from './utils/assert';
export { default as Stats } from './lib/stats';
export { default as Stat } from './lib/stat';
export { default as Log } from './lib/log';
export { COLOR } from './utils/color';
export default new Log({
  id: 'probe.gl'
});
export { addColor } from './utils/color';
export { leftPad, rightPad } from './utils/formatters';
export { autobind } from './utils/autobind';
export { default as LocalStorage } from './utils/local-storage';
export { default as getHiResTimestamp } from './utils/hi-res-timestamp';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/probe.gl/dist/esm/index.js
// module id = 110
// module chunks = 0